import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Modal } from 'antd';

export const PACKAGE_EXPIRED_KEY = 'packageExpiredNoticeShown';

/** 代登录硬跳转后，由工作台弹出套餐过期提示 */
export const PENDING_PACKAGE_EXPIRED_KEY = 'geo_pending_package_expired';

export const isTerminalUser = (user: any): boolean => Number(user?.user_type) === 4;

export const isPackageExpiredUser = (user: any): boolean =>
  isTerminalUser(user) && Boolean(user?.package_expired);

const formatEndTime = (ts?: number) => {
  const n = Number(ts || 0);
  if (!n) return '';
  const d = new Date(n * 1000);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (v: number) => String(v).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

/** 登录时展示套餐过期弹窗（同一会话仅一次） */
export const showPackageExpiredModal = (user?: any) => {
  if (!isPackageExpiredUser(user)) return;

  try {
    if (sessionStorage.getItem(PACKAGE_EXPIRED_KEY) === '1') return;
    sessionStorage.setItem(PACKAGE_EXPIRED_KEY, '1');
  } catch {
    // ignore
  }

  const endText = formatEndTime(user?.package_end_time);
  Modal.warning({
    title: '套餐已过期',
    icon: <ExclamationCircleOutlined />,
    content: (
      <div>
        <p>您的套餐已过期</p>
        {endText ? <p style={{ marginTop: 12, color: '#999' }}>套餐到期时间：{endText}</p> : null}
      </div>
    ),
    okText: '我知道了',
  });
};
